export default __webpack_public_path__ + "static/media/Chronic-Kidney-Disease-Management-1.127cebe1.jpg";